<template>
    <list-widget title="결제타입" minWidth="200" #default="{ attrs }">
        <v-select v-model="query['type']" v-bind="{ ...attrs, items }" dense flat solo hide-details @input="emit" />
    </list-widget>
</template>

<script>
import { CASH_TYPES } from "@/store/user-cashes";
import ListWidget from "@/components/console/dumb/list/list-widget.vue";

const items = [{ value: null, text: "전체" }].concat(...Object.values(CASH_TYPES));

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["type"]: query?.["type"] || null,
});

export default {
    components: {
        ListWidget,
    },
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["type"]) delete query["type"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
